import {
  DashboardOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  PieChartOutlined,
  BorderOutlined,
  EnvironmentOutlined,
  AntDesignOutlined,
  SafetyOutlined,
  HomeOutlined,
  StopOutlined,
  DotChartOutlined,
  NodeExpandOutlined,
  MailOutlined,
  MessageOutlined,
  CalendarOutlined,
  BulbOutlined,
  InfoCircleOutlined,
  CompassOutlined,
  LayoutOutlined,
  DesktopOutlined,
  FileDoneOutlined,
  CommentOutlined,
  RobotOutlined,
  PlusCircleOutlined,
  FundOutlined,
  VerifiedOutlined,
  ShoppingCartOutlined,
  BookOutlined,
  FileUnknownOutlined,
  ProfileOutlined,
  FundProjectionScreenOutlined,
  UsergroupAddOutlined,
  FormatPainterOutlined,
  NotificationOutlined,
  UserOutlined,
  ApartmentOutlined,
  SettingOutlined,
  BorderOuterOutlined,
  AlignCenterOutlined,
  CheckSquareOutlined,
  MedicineBoxOutlined,
  BuildOutlined,
  DeliveredProcedureOutlined,
  ExperimentOutlined,
  ShoppingFilled,
  ShopOutlined,
  FileImageOutlined,
  FileOutlined,
  SafetyCertificateOutlined,
  MoneyCollectOutlined,
  UserSwitchOutlined,
  ExpandOutlined,
  PercentageOutlined,
  CalculatorOutlined,
  AuditOutlined,
  FileProtectOutlined,
  StarOutlined,
  TransactionOutlined,
  AppstoreAddOutlined,
  TagsOutlined,
  FormOutlined,
  ContactsOutlined,
  CameraOutlined,
  PlayCircleOutlined,
  FlagOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { ShippingSVG } from "assets/svg/icon";
import * as routeKeys from "constants/RoutesKeys";
import { getAdminBasePath, getPageBasePath, getPagePreviousPath } from "constants/PageRoutes";

const dashBoardNavTree = [
  {
    key: "dashboards",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "sidenav.dashboard",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: 'dashboards-default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        title: 'sidenav.dashboard.default',
        isPage: true,
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const adminsNavTree = [
  {
    key: "admins",
    path: `${APP_PREFIX_PATH}/admins`,
    title: "Admins",
    icon: UserSwitchOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: routeKeys.subadminsKey,
        path: getAdminBasePath(routeKeys.subadminsKey),
        title: "Subadmins",
        isPage: true,
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.subadminRolesKey,
        path: getAdminBasePath(routeKeys.subadminRolesKey),
        title: "Roles & Permissions",
        isPage: true,
        icon: UserSwitchOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const pagesNavTree = [
  {
    key: "pages",
    path: `${APP_PREFIX_PATH}/pages`,
    title: "sidenav.pages",
    icon: InfoCircleOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [

      // {
      //   key: "general-pages",
      //   path: `${APP_PREFIX_PATH}/pages`,
      //   title: "Pages",
      //   isMenu: true,
      //   icon: FileOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: routeKeys.categoriesKey,
      //       path: getPageBasePath(routeKeys.categoriesKey),
      //       title: "Categories",
      //       isPage: true,
      //       icon: AppstoreAddOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //     {
      //       key: routeKeys.pagesKey,
      //       path: getPageBasePath(routeKeys.pagesKey),
      //       title: "Pages",
      //       isPage: true,
      //       icon: FileOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     }
      //   ],
      // },
      // {
      //   key: "locality",
      //   title: "Locality",
      //   path: `${APP_PREFIX_PATH}/pages`,
      //   icon: HomeOutlined,
      //   breadcrumb: false,
      //   isMenu: true,
      //   submenu: [
      //     {
      //       key: routeKeys.countryKey,
      //       path: `${APP_PREFIX_PATH}/pages/country-list`,
      //       title: "Country",
      //       isPage: true,
      //       icon: EnvironmentOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //     {
      //       key: routeKeys.stateKey,
      //       path: `${APP_PREFIX_PATH}/pages/state-list`,
      //       title: "State",
      //       isPage: true,
      //       icon: EnvironmentOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //   ],
      // },
      // {
      //   key: "dashboards-article-suggestion",
      //   path: `${APP_PREFIX_PATH}/dashboards/article-suggestion`,
      //   title: "Suggested Articles",
      //   permissionKey: "article_suggestions",
      //   icon: FormOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: routeKeys.widgetsKey,
        path: getPageBasePath(routeKeys.widgetsKey),
        title: "Widgets",
        isPage: true,
        icon: LayoutOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "about-the-church",
        path: `${APP_PREFIX_PATH}/pages`,
        title: "About the Church",
        isMenu: true,
        icon: BuildOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: routeKeys.historyKey,
            path: getPageBasePath(routeKeys.historyKey),
            title: "History",
            isPage: true,
            icon: BookOutlined,
            breadcrumb: false,
            submenu: [],
          },
            {
            key: routeKeys.positionKey,
            path: getPageBasePath(routeKeys.positionKey),
            title: "Positions",
            isPage: true,
            icon: TagsOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.administrationKey,
            path: getPageBasePath(routeKeys.administrationKey),
            title: "Administration",
            isPage: true,
            icon: AuditOutlined,
            breadcrumb: false,
            submenu: [],
          },
         
          {
            key: routeKeys.hierarchyKey,
            path: getPageBasePath(routeKeys.hierarchyKey),
            title: "Hierarchy",
            isPage: true,
            icon: ApartmentOutlined,
            breadcrumb: false,
            submenu: [],
          },
        
          {
            key: routeKeys.previousAdministratorsKey,
            path: getPagePreviousPath(routeKeys.administrationKey),
            title: "Previous Administrators",
            isPage: true,
            icon: TeamOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.parishPriestKey,
            path: getPageBasePath(routeKeys.parishPriestKey),
            title: "Parish Priest",
            isPage: true,
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.leadershipHistoryKey,
            path: getPageBasePath(routeKeys.leadershipHistoryKey),
            title: "Leadership History",
            isPage: true,
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.churchKey,
            path: getPageBasePath(routeKeys.churchKey),
            title: "Nearest Churches",
            isPage: true,
            icon: BuildOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.chapelKey,
            path: getPageBasePath(routeKeys.chapelKey),
            title: "Chapels & Kurishupally",
            isPage: true,
            icon: MedicineBoxOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.festivalsKey,
            path: getPageBasePath(routeKeys.festivalsKey),
            title: "Festivals",
            isPage: true,
            icon: CalendarOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: routeKeys.galleryKey,
        path: getPageBasePath(routeKeys.galleryKey),
        title: "Gallery",
        isPage: true,
        icon: FileImageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "details",
        path: `${APP_PREFIX_PATH}/pages`,
        title: "Details",
        isMenu: true,
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: routeKeys.quotesKey,
            path: getPageBasePath(routeKeys.quotesKey),
            title: "Quotes",
            isPage: true,
            icon: CommentOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.newsKey,
            path: getPageBasePath(routeKeys.newsKey),
            title: "News",
            isPage: true,
            icon: NotificationOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.occasionKey,
            path: getPageBasePath(routeKeys.occasionKey),
            title: "Occasion",
            isPage: true,
            icon: StarOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.advertisementKey,
            path: getPageBasePath(routeKeys.advertisementKey),
            title: "Advertisement",
            isPage: true,
            icon: FundOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.liveStreamingKey,
            path: getPageBasePath(routeKeys.liveStreamingKey),
            title: "Live Streaming",
            isPage: true,
            icon: PlayCircleOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.houseKey,
            path: getPageBasePath(routeKeys.houseKey),
            title: "e Directory",
            isPage: true,
            icon: HomeOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.eventsKey,
            path: getPageBasePath(routeKeys.eventsKey),
            title: "Events",
            isPage: true,
            icon: FormOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: routeKeys.incomePdfLinkKey,
            path: getPageBasePath(routeKeys.incomePdfLinkKey),
            title: "Varumana List",
            isPage: true,
            icon: FileOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "organization-menu",
        path: `${APP_PREFIX_PATH}/pages`,
        title: "Spiritual Organization",
        isMenu: true,
        icon: UsergroupAddOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: routeKeys.membersKey,
            path: getPageBasePath(routeKeys.membersKey),
            title: "Members",
            isPage: true,
            icon: TeamOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      // {
      //   key: routeKeys.officialContactKey,
      //   path: getPageBasePath(routeKeys.officialContactKey),
      //   title: "Official Contacts",
      //   isPage: true,
      //   icon: ContactsOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: routeKeys.templateKey,
        path: `${APP_PREFIX_PATH}/pages/template`,
        title: "Templates",
        isPage: true,
        icon: AppstoreOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.contactUsKey,
        path: getPageBasePath(routeKeys.contactUsKey),
        title: "Contact Us",
        isPage: true,
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.adminSettingsKey,
        path: getPageBasePath(routeKeys.adminSettingsKey),
        title: "Settings",
        isPage: true,
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.configSettingsKey,
        path: getPageBasePath(routeKeys.configSettingsKey),
        title: "Config Settings",
        isPage: true,
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

// {
//   key: 'dashboards-catalog-medicinetype',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/medicinetype/medicinetype-list`,
//   title: 'Medicine Type',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },
// {
//   key: 'dashboards-catalog-manufacturer',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/manufacturer/manufacturer-list`,
//   title: 'Manufacturer',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },
// {
//   key: 'dashboards-catalog-composition',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/composition/composition-list`,
//   title: 'Composition',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },

const docsNavTree = [
  {
    key: "docs",
    path: `${APP_PREFIX_PATH}/docs`,
    title: "sidenav.docs",
    icon: BookOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "docs-documentation",
        path: `${APP_PREFIX_PATH}/docs/documentation`,
        title: "sidenav.docs.documentation",
        isPage: true,
        icon: FileUnknownOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "docs-changelog",
        path: `${APP_PREFIX_PATH}/docs/documentation/changelog`,
        title: "sidenav.docs.changelog",
        isPage: true,
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [
  ...dashBoardNavTree,
  ...adminsNavTree,
  ...pagesNavTree,
  // ...appsNavTree,
  // ...componentsNavTree,
  // ...extraNavTree,
  ...docsNavTree,
];

export default navigationConfig;
